import React, { memo, useEffect, useState } from 'react';
import CommonDropdown from '../../sharedcomponents/CommonDropdown/CommonDropdown';
import { Endpoints, ReduxAction, maxPageSize } from './../../constants';
import smartHttp from '../../helpers/smartHttp';
import { store } from './../../redux/store';
import { useDispatch } from 'react-redux';
import { getSelectedContractNumbers } from '../../helpers/component-helper-methods';
const UsersDropdown = memo(
  ({
    contracts,
    callBackUsers,
    isGroupFilterApply,
    enableSelectAll = false,
    entitledOnly = false,
  }) => {
    const [usersResult, setUsersResult] = useState();
    const [dropDownLoader, setDropDownLoader] = useState(true);
    const dispatch = useDispatch();
    useEffect(() => {
      const reduceCallback = setTimeout(() => {
        getUsersDataSet();
      }, 1000);
      return () => clearTimeout(reduceCallback);
    }, [contracts]);

    const getUsersDataSet = async () => {
      try {
        let storeData = store.getState();
        let selectedEntitlementUser = storeData?.entitlementUsers;
        if (contracts?.length > 0 && contracts.some((el) => el.checked)) {
          const { contractNumbers, contractNumberFilter } =
            getSelectedContractNumbers(contracts);
          const filterClause = `contractNumber in(${contractNumberFilter})${
            entitledOnly ? ' and entitled:"Yes"' : ''
          }`;
          let queryParamsUser = {
            PageSize: maxPageSize,
            Field:
              'contactName,contactId,email,contractNumber,groupId,entitled',
            Filter: filterClause,
            Sort: 'contactName:asc',
          };
          const usersResponse = await smartHttp.get(
            Endpoints.userApi,
            queryParamsUser,
          );
          const userResp = usersResponse.data?.results;
          let responseData = userResp;
          if (isGroupFilterApply)
            responseData = userResp?.filter((x) => !x.groupId);

          // filter out duplicate users based on contactId
          const uniqueUsers = [];
          const uniqueContactIds = new Set();

          responseData?.forEach((user) => {
            if (!uniqueContactIds.has(user.contactId)) {
              uniqueContactIds.add(user.contactId);
              uniqueUsers.push(user);
            }
          });

          let tempState = uniqueUsers.map((el, i) => {
            return {
              id: i,
              checked:
                selectedEntitlementUser?.users?.length > 0
                  ? selectedEntitlementUser.users.some(
                      (x) => x.contactId === el.contactId,
                    )
                  : false,
              userLabel: `${el.contactName}  (${el.email})`,
              ...el,
            };
          });

          if (selectedEntitlementUser?.users?.length > 0) {
            tempState = tempState.sort((el) => {
              if (el.checked === true) return -1;
              else return 1;
            });
            dispatch({
              type: ReduxAction.selectedEntitlementUser,
              payload: [],
            });
          }

          setUsersResult(tempState);
        } else if (contracts) {
          setUsersResult([]);
        }
      } catch (err) {
        setDropDownLoader(false);
        setUsersResult([]);
      }
    };

    useEffect(() => {
      const updatedState = usersResult
        ?.filter((usersData) => usersData.checked === true)
        ?.map((filterusersData) => {
          return {
            contactName: `${filterusersData.contactName}  (${filterusersData.email})`,
            emailId: filterusersData.email,
            contactId: filterusersData.contactId,
            contractNumber: filterusersData.contractNumber,
          };
        });
      callBackUsers(updatedState);
    }, [usersResult]);

    const count =
      usersResult?.reduce(
        (counter, obj) => (obj?.checked === true ? (counter += 1) : counter),
        0,
      ) ?? 0;

    return (
      <CommonDropdown
        mode="multi"
        enableSelectAll={enableSelectAll}
        searchKeys={['userLabel']}
        enableSearch={true}
        labelKeyName="userLabel"
        ddOptionsKey="contactId"
        options={usersResult}
        setOptions={setUsersResult}
        ddName="users"
        ddDisabledMsg="User is part of a group and can not be entitled separately. Entitlements must be updated at group level."
        ddPlaceHolder="Users"
      />
    );
  },
  (op, np) => op?.contracts === np?.contracts,
);

export default UsersDropdown;
